import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'bergh-add-fp-alert',
    templateUrl: './add-fp-alert.component.html',
    styleUrls: ['./add-fp-alert.component.scss'],
    standalone: false
})
export class AddFpAlertComponent implements OnInit {
  @Output() cancel: EventEmitter<void> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

}
